module.exports = __webpack_public_path__ + "img/banner3_4_en.0705923f.png";